<template>
  <f7-popup
    :tablet-fullscreen="true"
    class="demo-popup"
    :opened="showPopUp"
    @popup:closed="emitClosePopUp"
  >
    <f7-view>
      <f7-page>
        <f7-navbar title="Nueva Línea de contrato">
          <f7-nav-right>
            <f7-link popup-close>
              <div class="margin-right">
                Cerrar
              </div>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <form
          ref="form"
          @submit.prevent="saveLine"
        >
          <div class="content-new-contract-line-popup">
            <f7-list>
              <li class="padding-horizontal padding-top-half">
                <div class="item-title item-label">
                  Selecciona una variedad
                </div>
              </li>
              <li>
                <a
                  class="item-link smart-select smart-select-init"
                  data-open-in="popup"
                  data-searchbar="true"
                  data-close-on-select="true"
                  data-searchbar-placeholder="Buscar variedad..."
                  data-popup-close-link-text="Cerrar"
                  data-virtual-list="true"
                >
                  <select
                    v-model="variety"
                    name="Variedades"
                  >
                    <option
                      value=""
                      selected
                      disabled
                    />
                    <option
                      v-for="(f) in selectableVarieties"
                      :key="f.id"
                      :value="f.id"
                    >
                      {{ f.name }}
                    </option>
                  </select>

                  <div class="item-content">
                    <div class="item-inner">
                      <div class="item-title">Variedades</div>
                      <div class="item-after">
                        {{ selectedVarietyTextAfter }}
                      </div>
                    </div>
                  </div>
                </a>
              </li>

              <!--
              <f7-list-item
                ref="variety"
                smart-select
                :value="variety"
                :smart-select-params="{
                  closeOnSelect: true,
                  searchbar: true,
                }"
                required
                validate
              >
                <select
                  name="variety"
                  @change="variety = $event.target.value"
                >
                  <option
                    selected
                    disabled
                    value=""
                  />
                  <option
                    v-for="(f) in selectableVarieties"
                    :key="f.id"
                    :value="f.id"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </f7-list-item>
              -->
              <f7-list-input
                :label="$t('common.quantity')"
                type="number"
                :placeholder="$t('common.quantity')"
                required
                class="padding-top"
                validate
                min="1"
                clear-button
                :value="quantity"
                @input="quantity = $event.target.value"
              />
              <f7-list-input
                :label="$t('common.price')"
                type="number"
                :placeholder="$t('common.price')"
                required
                validate
                min="0.01"
                step="0.00001"
                info="(máximo 5 decimales)"
                clear-button
                :value="price"
                @input="price = $event.target.value"
              />
              <f7-list-input
                label="Tipo de contrato"
                type="select"
                placeholder="Tipo de contrato"
                required
                validate
                clear-button
                :value="priceType"
                class="padding-bottom"
                @input="priceType = $event.target.value"
              >
                <option :value="0">
                  A tanto alzado
                </option>
                <option :value="1">
                  Por KG
                </option>
              </f7-list-input>
            </f7-list>
            <ComplementaryData
              :ref="dcReset"
              :entity="1054"
              :dcs-data="dcData"
              @data-changed="complementaryDataChanged"
            />
          </div>
          <div class="btn-fixed-bottom">
            <f7-button
              v-if="editable"
              type="submit"
              @click="clickForm"
            >
              {{ $t('common.save') }}
            </f7-button>
          </div>
        </form>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import MasterDataService from '@/js/services/contracts/MasterData';
import { HiNotification } from '@/js/common/HINotificationSupport';
import ComplementaryData from './ComplementaryData.vue';

export default {
  name: 'NewContractLinePopUp',
  components: { ComplementaryData },
  props: {
    popupOpened: { type: Boolean, default: false },
    line: { type: Object, default: undefined },
    editable: { type: Boolean, default: true },
  },

  emits: [
    'popup-close',
    'line-saved',
  ],

  data() {
    return {
      showPopUp: this.popupOpened,
      currentLine: this.line,
      selectableVarieties: [],
      variety: 0,
      varietyName: '',
      quantity: 0,
      price: 0,
      priceType: 0,
      dcData: {},
      dcReset: 0,
    };
  },
  computed: {
    finalLine() {
      return {
        id: this.currentLine.id || 0,
        variety: this.variety,
        varietyName: this.varietyName,
        quantity: this.quantity,
        price: this.price,
        priceType: Number.parseInt(this.priceType, 10),
        dcs: this.dcData,
      };
    },

    selectedVarietyTextAfter() {
      if (!Array.isArray(this.selectableVarieties)) {
        return '';
      }
      return this.selectableVarieties.find((item) => item.id === this.variety)?.name || '';
    },
  },
  watch: {
    popupOpened(newValue) {
      if (newValue) {
        this.dcReset += 1;
      }
      this.showPopUp = newValue;
    },
    line(newValue) {
      this.currentLine = newValue;
      this.lineChanged();
    },
    variety(newValue) {
      const variety = this.selectableVarieties.find((v) => v.id === Number.parseInt(newValue, 10));
      this.varietyName = (variety) ? variety.name : '';
    },
  },
  async mounted() {
    await this.loadVarieties();
  },
  methods: {
    emitClosePopUp() {
      this.showPopUp = false;
      this.clearInputs();
      const { form } = this.$refs;
      form.reset();
      // this.dcReset += 1;
      this.$emit('popup-close');
    },
    lineChanged() {
      if (this.currentLine.id !== undefined && this.currentLine.id !== 0) {
        this.variety = this.currentLine.variety;
        this.varietyName = this.currentLine.varietyName;
        this.quantity = this.currentLine.quantity;
        this.price = (this.currentLine.priceType === 0) ? this.currentLine.amount : this.currentLine.price;
        this.priceType = this.currentLine.priceType;
        this.dcData = {};
        this.dcData = this.currentLine.dcs;
      }
    },
    clearInputs() {
      this.variety = '';
      this.quantity = '';
      this.price = '';
      this.priceType = 0;
      this.dcData = {};
    },
    saveLine() {
      const returnLine = this.calculateFinalAmount(this.finalLine);

      this.$emit('line-saved', returnLine);
      this.emitClosePopUp();
    },
    clickForm() {
      const { form } = this.$refs;
      if (!form.checkValidity()) {
        if (this.variety === '' || this.variety <= 0) {
          HiNotification.Alert('Selecciona una variedad', '');
        } else {
          HiNotification.Alert('', 'Faltan campos obligatorios');
        }
      }
    },
    async loadVarieties() {
      const varieties = await MasterDataService.getAllVarieties();
      this.selectableVarieties = varieties;
    },
    complementaryDataChanged(newValue) {
      this.dcData = newValue;
    },
    calculateFinalAmount(line) {
      const returnLine = line;
      if (line.priceType === 0) { // global amount
        returnLine.amount = Number.parseFloat(line.price);
        returnLine.price = Number.parseFloat((line.price / line.quantity).toFixed(5));
      } else {
        returnLine.amount = line.price * line.quantity;
      }

      returnLine.amount = Number.parseFloat(returnLine.amount.toFixed(5));
      return returnLine;
    },
  },

};
</script>

<style lang="scss">
.content-new-contract-line-popup {
  height: calc(100vh - 136px);
  overflow-y: scroll;
}

.demo-popup {
  .page-content {
    background: var(--his-whispering-lilac);
  }

  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="month"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  input[type="select"],
  select,
  .smart-select .item-content .item-inner,
  textarea {
    border: 1px solid var(--his-silver);
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
  }

  .item-content {
    .item-inner {
      .item-input-wrap {
        input {
          height: 50px;
          padding-left: 10px;
        }

        select {
          height: 50px;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>
